import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Banner, StyledLimitedTimeOfferText, StyledRemainingText, StyledSaleBadge, StyledSaleBadgePercentageText, TextContainer, ConfettiContainer, SaleBadgeContainer } from './styled';
import { interpolateContent } from '../../utils/interpolateContent';
import { Confetti } from '@chegg-ui/confetti';
import { BadgeSize } from '../SaleBadge/SaleBadge';
var delimiter = ' || ';

/**
 * Sale banner with badge component
 */
var SaleBannerWithBadge = function SaleBannerWithBadge(_ref) {
  var content = _ref.content,
    totalSavingsPercentage = _ref.totalSavingsPercentage,
    saleBadgeContent = _ref.saleBadgeContent,
    dataTestId = _ref.dataTestId,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    className = _ref.className;
  var saleBadgeText = interpolateContent(saleBadgeContent, [{
    key: '${totalSavingsPercentage}',
    value: totalSavingsPercentage,
    formatPrefix: '',
    formatSuffix: ''
  }]);
  var _saleBadgeText$split = saleBadgeText.split(delimiter),
    _saleBadgeText$split2 = _slicedToArray(_saleBadgeText$split, 3),
    saleBadgeLineOne = _saleBadgeText$split2[0],
    saleBadgeLineTwo = _saleBadgeText$split2[1],
    saleBadgeLineThree = _saleBadgeText$split2[2];
  var _content$split = content.split(delimiter),
    _content$split2 = _slicedToArray(_content$split, 2),
    limitedTimeOfferText = _content$split2[0],
    remainingText = _content$split2[1];
  var parsedRemainingText = interpolateContent(remainingText, [{
    key: '${totalSavingsPercentage}',
    value: totalSavingsPercentage,
    formatPrefix: '',
    formatSuffix: ''
  }]);
  var confettiCustomCSS = {
    zIndex: 10000
  };
  return /*#__PURE__*/React.createElement(Banner, {
    "data-test": dataTestId,
    compact: compact,
    className: className
  }, /*#__PURE__*/React.createElement(StyledSaleBadge, {
    size: compact ? BadgeSize.Small : BadgeSize.Large,
    compact: compact
  }, /*#__PURE__*/React.createElement(SaleBadgeContainer, {
    compact: compact
  }, saleBadgeLineOne, ' ', /*#__PURE__*/React.createElement(StyledSaleBadgePercentageText, {
    compact: compact
  }, saleBadgeLineTwo), ' ', saleBadgeLineThree, /*#__PURE__*/React.createElement(ConfettiContainer, null, /*#__PURE__*/React.createElement(Confetti, {
    customCSS: confettiCustomCSS
  })))), /*#__PURE__*/React.createElement(TextContainer, {
    compact: compact
  }, /*#__PURE__*/React.createElement(StyledLimitedTimeOfferText, null, limitedTimeOfferText), /*#__PURE__*/React.createElement(StyledRemainingText, null, parsedRemainingText)));
};
export default SaleBannerWithBadge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SaleBannerWithBadge/SaleBannerWithBadge.js
// module id = 3984
// module chunks = 11